import React from 'react';

const PolyvalentModel = (data) => {
    const model = {...data.item, sourceItems: data?.sourceItems}
    return model
};

export default PolyvalentModel;
